import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { TextS } from '../../../../../../infra/dls/components/typography';
import { Tooltip } from '../../../../../../infra/dls/components/tooltip';
import { useSession, getSessionShop } from '../../../../../../infra/session';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
import { BarberAvatarContainer as BarberAvatar } from '../../../../components/barber-avatar/barber-avatar.container';
var getName = function (firstName, lastName) {
    return "".concat(firstName, " ").concat(lastName || '');
};
export var buildCreatedByProps = function (campaign) {
    var _a;
    var result = {
        thumbnail: (_a = campaign.createdBy) === null || _a === void 0 ? void 0 : _a.thumbnail,
        type: campaign.createdBy.type,
    };
    if (result.type === 'barber') {
        result.firstName = campaign.createdBy.firstName;
        result.lastName = campaign.createdBy.lastName;
        result.name = getName(result.firstName, result.lastName);
    }
    else {
        result.name = campaign.createdBy.name;
    }
    return result;
};
export var CreatedBy = function (_a) {
    var _b;
    var firstName = _a.firstName, lastName = _a.lastName, name = _a.name, thumbnail = _a.thumbnail, type = _a.type;
    var session = useSession().data;
    var shop = getSessionShop(session);
    var shopLogo = (_b = shop === null || shop === void 0 ? void 0 : shop.logo) === null || _b === void 0 ? void 0 : _b.url;
    var isTabletOrSmaller = useBreakpoints().isTabletOrSmaller;
    var getAvatarUrl = useCallback(function () {
        var avatarUrl = null;
        if (thumbnail) {
            avatarUrl = thumbnail;
        }
        else if (type === 'shop' && shopLogo) {
            avatarUrl = shopLogo;
        }
        return avatarUrl;
    }, [shopLogo, thumbnail, type]);
    var AvatarNode = useMemo(function () { return (_jsx(BarberAvatar, { id: "avatar", photoUrl: getAvatarUrl(), firstName: firstName !== null && firstName !== void 0 ? firstName : name, lastName: lastName, size: "big" })); }, [getAvatarUrl, firstName, name, lastName]);
    if (isTabletOrSmaller) {
        return AvatarNode;
    }
    return (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: AvatarNode }), _jsx(Tooltip.Content, { placement: "right", children: _jsx(TextS, { color: "primary-inverse", children: name }) })] }));
};
